import { useEffect, useRef, useState } from "react";
import { useStore } from "../../Hooks/use-store";
import { observer } from "mobx-react-lite";
import { generateQuestionsArray } from "../../utils";
import { displayQuestions } from "../../utilities/displayQuestions";

const questionsArray = (partQns: any) => {
  let allListOfQuestions =
  partQns?.questions?.length > 0 &&
  partQns.questions.map((item: any) => {
      let total = [];
      if (item["listOfQuestions"] && item.questionType !== "Table Completion") {
        let arr: any = [];
        let data = item["listOfQuestions"];
        data.forEach((item: any) => {
          arr.push(item["questionId"]);
        });
        total.push(arr.flat(Infinity));
      } else {
        total.push(generateQuestionsArray(item.questionRange));
      }
      return total;
    });
  let result =
    allListOfQuestions &&
    allListOfQuestions.length > 0 &&
    allListOfQuestions.flat(Infinity);
  return result;
};

const combineAnswers = (...rest: any) => {
  return rest.filter((arr: any) => arr !== undefined).flat(Infinity);
};

const combineUserAnswers = (setPartAllAnswers: any, ...rest: any) => {
  setPartAllAnswers(rest.flat(Infinity));
};

const isQuestionAnswered = (partAllAnswers: any, number: any) => {
  return partAllAnswers.some((item: any) => {
    if (Array.isArray(item["answer"])) {
      return item["answer"].length < 2 ? false : item["qId"] == number;
    } else {
      return item["answer"] === "" ? false : item["qId"] == number;
    }
  });
};
const Tab = ({
  label,
  onClick,
  isActive,
  part1Questions,
  part2Questions,
  part3Questions,
  part4Questions,
}: any) => {
  const { startTestStoreListening } = useStore();
  const {
    part1SingleAnswer,
    part1MultipleAnswer,
    part1ShortAnswer,
    part1NoteCompletionAnswer,
    part1SenetenceComplete,
    part1TableCompletionAnswer,
    part1PlanDiagramAnswer,
    part2SingleAnswer,
    part2MultipleAnswer,
    part2NoteCompletionAnswer,
    part2SenetenceComplete,
    part2TableCompletionAnswer,
    part2ShortAnswer,
    part2PlanDiagramAnswer,
    part3SingleAnswer,
    part3MultipleAnswer,
    part3NoteCompletionAnswer,
    part3SenetenceComplete,
    part3TableCompletionAnswer,
    part3ShortAnswer,
    part3PlanDiagramAnswer,
    part4SingleAnswer,
    part4MultipleAnswer,
    part4NoteCompletionAnswer,
    part4SenetenceComplete,
    part4TableCompletionAnswer,
    part4ShortAnswer,
    part4PlanDiagramAnswer,
  } = startTestStoreListening;

  let partOneAllAnswers = combineAnswers(
    part1SingleAnswer || [],
    part1MultipleAnswer || [],
    part1NoteCompletionAnswer || [],
    part1SenetenceComplete || [],
    part1TableCompletionAnswer || [],
    part1ShortAnswer || [],
    part1PlanDiagramAnswer || []
  );
  let partTwoAllAnswers = combineAnswers(
    part2SingleAnswer || [],
    part2MultipleAnswer || [],
    part2NoteCompletionAnswer || [],
    part2SenetenceComplete || [],
    part2TableCompletionAnswer || [],
    part2ShortAnswer || [],
    part2PlanDiagramAnswer || []
  );
  let partThreeAllAnswers = combineAnswers(
    part3SingleAnswer || [],
    part3MultipleAnswer || [],
    part3NoteCompletionAnswer || [],
    part3SenetenceComplete || [],
    part3TableCompletionAnswer || [],
    part3ShortAnswer || [],
    part3PlanDiagramAnswer || []
  );
  let partFourAllAnswers = combineAnswers(
    part4SingleAnswer || [],
    part4MultipleAnswer || [],
    part4NoteCompletionAnswer || [],
    part4SenetenceComplete || [],
    part4TableCompletionAnswer || [],
    part4ShortAnswer || [],
    part4PlanDiagramAnswer || []
  );

  return (
    <button
      className={` flex px-4 pt-4 border-t-[5px] rounded-sm font-extrabold cursor-default ${
        isActive ? "border-red-600 text-[#E31837] " : "border-transparent"
      }`}
      onClick={onClick}
    >
      <div className="pt-1">{label}</div>
      {label === "Part 1" &&
        isActive &&
        displayQuestions(part1Questions, partOneAllAnswers,isQuestionAnswered)}
      {label === "Part 2" &&
        isActive &&
        displayQuestions(part2Questions, partTwoAllAnswers,isQuestionAnswered)}
      {label === "Part 3" &&
        isActive &&
        displayQuestions(part3Questions, partThreeAllAnswers,isQuestionAnswered)}
      {label === "Part 4" &&
        isActive &&
        displayQuestions(part4Questions, partFourAllAnswers,isQuestionAnswered)}
    </button>
  );
};

const Tabs = ({ tabs }: any) => {
  const { resultsStoreListening, startTestStoreListening } = useStore();
  const {
    part1Questions,
    part2Questions,
    part3Questions,
    part4Questions,
    setPart1AllAnswers,
    setPart2AllAnswers,
    setPart3AllAnswers,
    setPart4AllAnswers,
    part1SingleAnswer,
    part1MultipleAnswer,
    part1ShortAnswer,
    part1NoteCompletionAnswer,
    part1SenetenceComplete,
    part1TableCompletionAnswer,
    part1PlanDiagramAnswer,
    part2SingleAnswer,
    part2MultipleAnswer,
    part2NoteCompletionAnswer,
    part2SenetenceComplete,
    part2TableCompletionAnswer,
    part2ShortAnswer,
    part2PlanDiagramAnswer,
    part3SingleAnswer,
    part3MultipleAnswer,
    part3NoteCompletionAnswer,
    part3SenetenceComplete,
    part3TableCompletionAnswer,
    part3ShortAnswer,
    part3PlanDiagramAnswer,
    part4SingleAnswer,
    part4MultipleAnswer,
    part4NoteCompletionAnswer,
    part4SenetenceComplete,
    part4TableCompletionAnswer,
    part4ShortAnswer,
    part4PlanDiagramAnswer,
  } = startTestStoreListening;

  let partOneQuestions = questionsArray(part1Questions);
  let partTwoQuestions = questionsArray(part2Questions);
  let partThreeQuestions = questionsArray(part3Questions);
  let partFourQuestions = questionsArray(part4Questions);

  const handleTabClick = (index: any) => {
    combineUserAnswers(
      setPart1AllAnswers,
      part1SingleAnswer,
      part1MultipleAnswer,
      part1NoteCompletionAnswer,
      part1SenetenceComplete,
      part1TableCompletionAnswer,
      part1ShortAnswer,
      part1PlanDiagramAnswer
    );
    combineUserAnswers(
      setPart2AllAnswers,
      part2SingleAnswer,
      part2MultipleAnswer,
      part2NoteCompletionAnswer,
      part2SenetenceComplete,
      part2TableCompletionAnswer,
      part2ShortAnswer,
      part2PlanDiagramAnswer
    );
    combineUserAnswers(
      setPart3AllAnswers,
      part3SingleAnswer,
      part3MultipleAnswer,
      part3NoteCompletionAnswer,
      part3SenetenceComplete,
      part3TableCompletionAnswer,
      part3ShortAnswer,
      part3PlanDiagramAnswer
    );
    combineUserAnswers(
      setPart4AllAnswers,
      part4SingleAnswer,
      part4MultipleAnswer,
      part4NoteCompletionAnswer,
      part4SenetenceComplete,
      part4TableCompletionAnswer,
      part4ShortAnswer,
      part4PlanDiagramAnswer
    );
    resultsStoreListening.setActiveTab(index);
    if (index === 0) {
      resultsStoreListening.setStepManagement("Part 1", "", "");
    } else if (index === 1) {
        resultsStoreListening.setStepManagement("Part 2", "Part 2", "");
    } else if (index === 2) {
        resultsStoreListening.setStepManagement("Part 3", "Part 3", "");
    } else {
        resultsStoreListening.setStepManagement("Part 4", "Part 4", "");
    }
  };


  return (
    <div className="flex  rounded-t-[8px]  pl-4">
      <TabComponent
        testType={startTestStoreListening.testType}
        handleTabClick={handleTabClick}
        partOneQuestions={partOneQuestions}
        partTwoQuestions={partTwoQuestions}
        partThreeQuestions={partThreeQuestions}
        partFourQuestions={partFourQuestions}
        tabs={tabs}
        activeTab={resultsStoreListening.activeTab}
      />
    </div>
  );
};

const TabComponent = (props : any) => {
  const {testType,handleTabClick,partOneQuestions,partTwoQuestions,partThreeQuestions,partFourQuestions,tabs,activeTab} = props;
  if (testType === "part1") {
    return (
      <Tab
        key={0}
        label="Part 1"
        onClick={() => handleTabClick(0)}
        isActive={true}
        part1Questions={partOneQuestions}
        part2Questions={""}
        part3Questions={""}
      />
    );
  } else if (testType === "part2") {
    return (
      <Tab
        key={1}
        label="Part 2"
        onClick={() => handleTabClick(1)}
        isActive={true}
        part1Questions={""}
        part2Questions={partTwoQuestions}
        part3Questions={""}
      />
    );
  } else if (testType === "part3") {
    return (
      <Tab
        key={2}
        label="Part 3"
        onClick={() => handleTabClick(2)}
        isActive={true}
        part1Questions={""}
        part2Questions={""}
        part3Questions={partThreeQuestions}
      />
    );
  } else if (testType === "part4") {
    return (
      <Tab
        key={3}
        label="Part 4"
        onClick={() => handleTabClick(3)}
        isActive={true}
        part1Questions={""}
        part2Questions={""}
        part3Questions={""}
        part4Questions={partFourQuestions}
      />
    );
  } else {
    return tabs.map((tab: any, i: any) => (
      <Tab
        key={tab} //changed to avoid sonarQube issue
        label={tab}
        // onClick={() => handleTabClick(index)}
        isActive={i === activeTab}
        part1Questions={partOneQuestions}
        part2Questions={partTwoQuestions}
        part3Questions={partThreeQuestions}
        part4Questions={partFourQuestions}
      />
    ));
  }
};


const PartTestLayoutListening = observer(
  ({
    children,
    buttonTitle,
    partType,
    nextStep,
    title,
    description,
    audio,
  }: any) => {
    const tabs = ["Part 1", "Part 2", "Part 3", "Part 4"];
    const [isAudio, setIsAudio] = useState(false);
    const [progressWidth, setProgressWidth] = useState(80);
    const audioRef = useRef<HTMLAudioElement>(null);

    const handleProgressBarClick = (event: any) => {
      const progressBarWidth = event.target.clientWidth;

      const clickedPositionX =
        event.clientX - event.target.getBoundingClientRect().left;
      const clickedProgress = (clickedPositionX / progressBarWidth) * 100;
      setProgressWidth(clickedProgress);
    };

    useEffect(() => {
      if (audioRef.current) {
        // Assuming the progressWidth is a percentage (0-100)
        const volumeLevel = progressWidth / 100;
        audioRef.current.volume = volumeLevel;
      }
    }, [progressWidth]);
    useEffect(() => {
      setIsAudio(true);
      return () => {
        setIsAudio(false);
      };
    }, [audio]);

    return (
      <div className="flex flex-col ">
        {isAudio && (
          <audio
            ref={audioRef}
            autoPlay
            src={audio}
            onEnded={() => setIsAudio(false)}
          >
            <track
              kind="captions"
              src=""
              srcLang="en"
              label="No captions available"
            />
          </audio>
        )}
        <div className="flex items-center justify-between border h-full border-[#E3E5E9] z-[#999] p-4 m-6 bg-white rounded-lg">
          <div>
            <p className="font-extrabold text-base md:text-xl mb-2">{title}</p>
            <h5>{description}</h5>
          </div>

          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="mr-2"
            >
              <path
                d="M14.5791 2.32579C14.4529 2.26433 14.3121 2.23948 14.1726 2.25406C14.033 2.26865 13.9004 2.32208 13.7897 2.40829L7.24219 7.49985H3C2.60218 7.49985 2.22064 7.65788 1.93934 7.93919C1.65804 8.22049 1.5 8.60202 1.5 8.99985V14.9998C1.5 15.3977 1.65804 15.7792 1.93934 16.0605C2.22064 16.3418 2.60218 16.4998 3 16.4998H7.24219L13.7897 21.5914C13.9005 21.6775 14.0332 21.7309 14.1728 21.7453C14.3124 21.7597 14.4533 21.7347 14.5793 21.6731C14.7054 21.6115 14.8117 21.5157 14.8861 21.3967C14.9604 21.2777 14.9999 21.1402 15 20.9998V2.99985C15 2.85934 14.9606 2.72166 14.8861 2.60248C14.8117 2.48331 14.7053 2.38743 14.5791 2.32579ZM3 8.99985H6.75V14.9998H3V8.99985ZM13.5 19.4661L8.25 15.3833V8.61641L13.5 4.5336V19.4661ZM18.5625 9.5211C19.1657 10.2059 19.4986 11.0872 19.4986 11.9998C19.4986 12.9125 19.1657 13.7938 18.5625 14.4786C18.43 14.6242 18.2456 14.7119 18.049 14.7227C17.8524 14.7335 17.6595 14.6666 17.5118 14.5364C17.3642 14.4062 17.2736 14.2231 17.2597 14.0268C17.2458 13.8304 17.3097 13.6364 17.4375 13.4867C17.7992 13.0759 17.9988 12.5473 17.9988 11.9998C17.9988 11.4524 17.7992 10.9238 17.4375 10.513C17.3097 10.3633 17.2458 10.1693 17.2597 9.97293C17.2736 9.77656 17.3642 9.59353 17.5118 9.46333C17.6595 9.33314 17.8524 9.26623 18.049 9.27703C18.2456 9.28784 18.43 9.3755 18.5625 9.5211ZM23.25 11.9998C23.2511 13.845 22.5711 15.6257 21.3403 17.0005C21.2067 17.145 21.0216 17.2313 20.825 17.2406C20.6284 17.2499 20.436 17.1815 20.2893 17.0503C20.1426 16.919 20.0535 16.7353 20.041 16.5388C20.0286 16.3424 20.0939 16.1489 20.2228 16.0002C21.2066 14.9001 21.7505 13.4761 21.7505 12.0003C21.7505 10.5245 21.2066 9.1005 20.2228 8.00047C20.1553 7.9274 20.103 7.84163 20.0689 7.74815C20.0349 7.65466 20.0197 7.55533 20.0245 7.45595C20.0292 7.35657 20.0536 7.25911 20.0963 7.16926C20.1391 7.07942 20.1993 6.99897 20.2734 6.93261C20.3475 6.86625 20.4341 6.81531 20.5281 6.78274C20.6222 6.75018 20.7217 6.73665 20.821 6.74293C20.9203 6.74922 21.0173 6.7752 21.1065 6.81936C21.1957 6.86352 21.2751 6.92498 21.3403 7.00016C22.5714 8.37436 23.2515 10.1549 23.25 11.9998Z"
                fill="#3C424C"
              />
            </svg>
            <button
              className=" h-2 w-24 bg-[#E3E5E9] rounded-full"
              onClick={handleProgressBarClick}
            >
              <div
                className=" top-0 left-0 h-full bg-red-500 rounded-full"
                style={{ width: `${progressWidth}%`, borderRadius: "inherit" }}
              ></div>
            </button>
          </div>
        </div>
        <div className="">{children}</div>

        <div className="fixed bg-white flex justify-between  border-t border-t-[#E3E5E9]  bottom-0 w-full">
          <div>
            <Tabs tabs={tabs} />
          </div>
          <div>
            <button
              //disabled={disabled}
              onClick={nextStep}
              className={` ${
                false
                  ? "bg-[#ABB2BE] text-white"
                  : "text-[#E31837] border-[#E31837] "
              } border my-4 mr-4 px-4 py-2 rounded-full `}
            >
              {buttonTitle}
            </button>
          </div>
        </div>
      </div>
    );
  }
);

export default PartTestLayoutListening;